import script from "./CertificateCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./CertificateCreateModal.vue?vue&type=style&index=0&id=6563dec4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6563dec4"]])

export default __exports__